import { useState } from 'react';
import { Lock, LockOpen, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Sheet } from '@gravity-ui/uikit';

import { useBlockUserMutation } from 'store/api/private/user-api/admin-api';

import { BLOCK, BLOCK_ACC, BLOCK_QUESTION, CANCEL } from '../../constants';
import { toast } from 'react-toastify';

import styles from '../modals/styles.module.scss';

interface Person {
	id: number;
	email: string;
	role: string;
	firstName: string;
	middleName: string;
	lastName: string;
	establishment: {
		id?: number;
		name?: string | null;
	} | null;
	imageUrl: string;
	region: {
		code?: number;
		fullname: string;
		guid?: string;
		name?: string;
	};
	specialty: string;
	createdDate: string;
	active: boolean;
}

interface AccountBlockSheetProps {
	account: Person;
	onAdd: () => void;
	updateAccountStatus: (updatedAccount: Person) => void;
}

export const AccountBlockSheet = ({ account, onAdd, updateAccountStatus }: AccountBlockSheetProps) => {
	const [open, setOpen] = useState(false);

	const [blockAcount] = useBlockUserMutation();

	const onSubmit = () => {
		blockAcount({ email: account.email });
		setOpen(false);
		updateAccountStatus({ ...account, active: true });
		onAdd();
		toast.success('Аккаунт специалиста успешно заблокирован');
	};

	return (
		<>
			<Button view="flat" size="l" onClick={() => setOpen(true)}>
				<Icon data={LockOpen} size={16} />
				Заблокировать
			</Button>

			<Sheet visible={open} onClose={() => setOpen(false)} className={styles.sheet} title={BLOCK_ACC}>
				<div className={styles.sheet__close}>
					<Button onClick={() => setOpen(false)} view="flat">
						<Icon data={Xmark} size={16} />
					</Button>
				</div>

				<div className={styles.modal__question}>{BLOCK_QUESTION}</div>

				<div className={styles.modal__btns}>
					<Button size="xl" view="flat-secondary" onClick={() => setOpen(false)}>
						{CANCEL}
					</Button>
					<Button
						size="xl"
						view="outlined-danger"
						onClick={() => {
							onSubmit();
							setOpen(false);
						}}
					>
						{BLOCK}
					</Button>
				</div>
			</Sheet>
		</>
	);
};
